module.exports = __webpack_public_path__ + "static/media/miemi_icon.34f9c878.png";